module.exports = __webpack_public_path__ + "static/nccga-5d1e2259f0c9a9c8986f818460948bf7.png";